"use client";

import { register } from "@ebay/nice-modal-react";

import { themeStore } from "@up/data";
import {
  LEAD_CAPTURE_TOPICS_V1_MODAL_ID,
  LEAD_CAPTURE_UPCOMING_COURSE_V2_MODAL_ID,
  LeadCaptureSyllabusv1Modal,
  LeadCaptureUpcomingCoursev2Modal,
  useModalTimer,
} from "@up/lead-capture";
import { AppShell } from "@up/next-customization";

import { LIBRARY_THEME } from "~/lib/theme";

import type { ReactNode } from "react";

interface ProvidersProps {
  children: ReactNode;
}

register(LEAD_CAPTURE_TOPICS_V1_MODAL_ID, LeadCaptureSyllabusv1Modal);
register(
  LEAD_CAPTURE_UPCOMING_COURSE_V2_MODAL_ID,
  LeadCaptureUpcomingCoursev2Modal,
);

// Set theme at module level
themeStore.set(LIBRARY_THEME);

if (typeof window !== "undefined") {
  window.leadCaptureConfig = {
    topics: [
      "Business",
      "Communications",
      "Law and Government",
      "Medicine",
      "STEM",
      "College Credit",
    ],
  };
}

export function Providers({ children }: ProvidersProps) {
  useModalTimer({
    modalID: LEAD_CAPTURE_TOPICS_V1_MODAL_ID,
  });

  return <AppShell>{children}</AppShell>;
}
